import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { PraiseService } from 'app/personal-growth/praise/praise.service';
import { CoreService } from 'app/shared/services/core.service';
import { Router } from '@angular/router';
import { Pp360SpinnerService } from 'app/pp360-components/pp360-spinner/pp360-spinner.service';
import { WallService } from 'app/employee/wall/wall.service';
@Component({
  selector: 'app-table-skills-by-person',
  templateUrl: './table-skills-by-person.component.html',
  styleUrls: [
    './table-skills-by-person.component.scss',
    '../tables.scss',
    '../../../../common_styles.scss',
  ],
})
export class TableSkillsByPersonComponent implements OnInit {
  @Input() dateRange: string;
  @Input() viewMode: string;
  @Input() mode;
  @Input() Mobile: string;

  @Output() OnLoading = new EventEmitter();
  @Output() openComp = new EventEmitter();
  @Output() OnLoaded = new EventEmitter();

  filteredItems: any;
  items: any;
  currentFilter: any;
  userinfo: any;
  @Input() skillPerson: any;
  @Input() radioType: any;
  opens: boolean = false;
  subEmp: any;
  profileName: string;
  fname: string;
  mname: string;
  lname: string;

  constructor(
    private praiseService: PraiseService,
    private ref: ChangeDetectorRef,
    public coreService: CoreService,
    public route: Router,
    private service: WallService,
    private pp360SpinnerService: Pp360SpinnerService
  ) {}

  ngOnInit() {
    this.userinfo = this.coreService.getUserInfo();
    this.reload(this.viewMode, this.dateRange);
  }
  isExpands(itemId: any) {
    for (let i of this.skillPerson) {
      if (itemId === i.id) {
        i['isExpanded'] = !i['isExpanded'];
      } else {
        i['isExpanded'] = false;
      }
    }
  }
  updateCurrentFilter() {
    this.currentFilter = {
      dateRange: this.dateRange,
      viewMode: this.viewMode, // Given/Received
      type: this.radioType,
    };
  }
  openComponent(data) {
    this.subEmp = data;
    this.openComp.next([data, 'skillEmployee']);
  }
  reload(data, dateRange) {
    this.updateCurrentFilter();
    this.OnLoading.emit();
    let filter = JSON.parse(JSON.stringify(this.currentFilter));
    filter.viewMode = data;
    filter.isByPerson = true;
    filter.dateRange = dateRange;
    this.pp360SpinnerService.showSpinner(true);
    this.praiseService
      .getItemsPersonsByBehaviorSkills(null, null, filter)
      .subscribe((items: any) => {
        this.OnLoaded.emit();
        this.items = items;
        this.filteredItems = JSON.parse(JSON.stringify(this.items));
        // console.log(this.filteredItems);
        // this.filteredItems.sort((a, b) => {
        //   return a.CountSkills > b.CountSkills ? -1 : (a.CountSkills < b.CountSkills ? 1 : 0);
        // });
        this.filteredItems.sort((a, b) => {
          if (this.mode === 'Skills') {
            if (a.CountSkills === b.CountSkills) {
              if (a.Pats?.Tot === b.Pats?.Tot) {
                if (a.Feedbacks?.Avg === b.Feedbacks?.Avg) {
                  return a.Tokens?.Tot > b.Tokens?.Tot
                    ? -1
                    : a.Tokens?.Tot < b.Tokens?.Tot
                      ? 1
                      : 0;
                }
                return a.Feedbacks?.Avg > b.Feedbacks?.Avg
                  ? -1
                  : a.Feedbacks?.Avg < b.Feedbacks?.Avg
                    ? 1
                    : 0;
              }
              return a.Pats?.Tot > b.Pats?.Tot
                ? -1
                : a.Pats?.Tot < b.Pats?.Tot
                  ? 1
                  : 0;
            }
            return a.CountSkills > b.CountSkills
              ? -1
              : a.CountSkills < b.CountSkills
                ? 1
                : 0;
          }
          if (this.mode === 'Behaviors') {
            if (a.CountBehaviors === b.CountBehaviors) {
              if (a.Pats?.Tot === b.Pats?.Tot) {
                if (a.Feedbacks?.Avg === b.Feedbacks?.Avg) {
                  return a.Tokens?.Tot > b.Tokens?.Tot
                    ? -1
                    : a.Tokens?.Tot < b.Tokens?.Tot
                      ? 1
                      : 0;
                }
                return a.Feedbacks?.Avg > b.Feedbacks?.Avg
                  ? -1
                  : a.Feedbacks?.Avg < b.Feedbacks?.Avg
                    ? 1
                    : 0;
              }
              return a.Pats?.Tot > b.Pats?.Tot
                ? -1
                : a.Pats?.Tot < b.Pats?.Tot
                  ? 1
                  : 0;
            }
            return a.CountBehaviors > b.CountBehaviors
              ? -1
              : a.CountBehaviors < b.CountBehaviors
                ? 1
                : 0;
          }
        });
        for (let item of this.filteredItems) {
          this.service.getEmployeeInfo(item.Id).subscribe((data: any) => {
            const employee = this.service.profiles.find(
              (x) => x.Id === item.Id
            );
            // console.log(item.Name.length);
            if (item.Name.length > 22) {
              let n = item.Name.split(' ');
              this.fname = item.Name.split(' ')[0][0] + '.';
              this.lname = n[n.length - 1];
              this.profileName = this.fname + ' ' + this.lname;
              this.profileName = this.profileName.trim();
            } else {
              this.profileName = item.Name;
            }
            item['profileName'] = this.profileName;
          });
        }
        this.pp360SpinnerService.showSpinner(false);
      });
  }

  getTooltip(t, useViewMode = false) {
    let key = 'PRAISES.' + t;
    if (useViewMode) {
      key += this.viewMode;
    } else {
      key += this.radioType;
    }

    return this.coreService.getTranslation(key);
  }

  // updateCurrentFilter() {
  //   this.currentFilter = {
  //     dateRange: this.dateRange,
  //     viewMode: this.viewMode, // Given/Received
  //     type: this.radioType
  //   };
  // }

  findMyGuru(itemId: string) {}

  goToProfile(id) {
    this.route.navigate(['/User/story'], {
      queryParams: { idVisitor: id },
      replaceUrl: true,
    });
  }

  expandRow(item: any) {
    // console.log(item);

    // if(item.ShowDetails){
    //   this.opens=true;
    // }
    // else{
    //   this.opens=false;
    // }
    // console.log(item);

    if (item.ShowDetails) {
      item.ShowDetails = false;
      this.opens = false;
      this.ref.detectChanges();
    } else {
      this.filteredItems.forEach((element: any) => {
        element.ShowDetails = false;
        this.opens = false;
      });
      if (!item.SkillsList) {
        this.updateCurrentFilter();
        let nextFilter = JSON.parse(JSON.stringify(this.currentFilter));
        if (this.currentFilter.type == 'Skills') {
          nextFilter.type = 'SkillsByEmployee';
        } else {
          nextFilter.type = 'BehaviorsByEmployee';
        }
        this.OnLoading.emit();
        this.praiseService
          .getItemsPersonsByBehaviorSkills(item.Id, null, nextFilter)
          .subscribe((skills: any) => {
            this.OnLoaded.emit();
            item.SkillsList = skills;
            item.ShowDetails = true;
            this.opens = true;
            for (let i of item.SkillsList) {
              i['sortingValue'] =
                (i?.Pats?.Tot || 0) +
                (i?.Feedbacks?.Avg || 0) +
                (i?.Tokens?.Tot || 0);
            }

            item.SkillsList.sort((a, b) => {
              return a.sortingValue > b.sortingValue
                ? -1
                : a.sortingValue < b.sortingValue
                  ? 1
                  : 0;
            });

            this.ref.detectChanges();
          });
      } else {
        item.ShowDetails = true;
        this.opens = true;
        this.ref.detectChanges();
      }
    }
  }

  sort(event: any, type: string, subtype: string = '') {
    let currentSort;
    for (let item of this.filteredItems) {
      item.ShowDetails = false;
    }
    if ($(event.target).hasClass('sort-asc')) {
      $(event.target).removeClass('sort-asc'),
        $(event.target).addClass('sort-desc');
      currentSort = 'desc';
    } else {
      $(event.target).removeClass('sort-desc'),
        $(event.target).addClass('sort-asc');
      currentSort = 'asc';
    }

    this.filteredItems.sort((a, b) => {
      switch (type) {
        case 'Name':
          if (!a || !a.Name || !b || !a.Name) return -1;
          if (currentSort === 'desc') {
            return a.Name.toLowerCase().trim() > b.Name.toLowerCase().trim()
              ? -1
              : a.Name.toLowerCase().trim() < b.Name.toLowerCase().trim()
                ? 1
                : 0;
          } else {
            return a.Name.toLowerCase().trim() > b.Name.toLowerCase().trim()
              ? 1
              : a.Name.toLowerCase().trim() < b.Name.toLowerCase().trim()
                ? -1
                : 0;
          }
          break;

        case 'CountSkills':
          if (currentSort === 'desc') {
            return b.CountSkills - a.CountSkills;
          } else {
            return a.CountSkills - b.CountSkills;
          }
          break;
        case 'CountBehaviors':
          if (currentSort === 'desc') {
            return b.CountBehaviors - a.CountBehaviors;
          } else {
            return a.CountBehaviors - b.CountBehaviors;
          }
          break;
        default:
          const valueA =
            !a || !a[type] || !a[type][subtype] ? 0 : a[type][subtype];
          const valueB =
            !b || !b[type] || !b[type][subtype] ? 0 : b[type][subtype];

          if (currentSort === 'desc') {
            return valueB - valueA;
          } else {
            return valueA - valueB;
          }

          break;
      }
    });
  }
}
